
export default function (value, trunc, ellipsis = '...') {
  if (!value || typeof value !== 'string') return
  return value.length > trunc ? `${value.slice(0, trunc)}${ellipsis}` : value
}



// WEBPACK FOOTER //
// ./src/filters/truncate.js